/**
 * P1-S3 — real panic exit.
 *
 * Drops the card from memory, resets the local game state and replaces the
 * game's history entry with the decoy notes page, so Back never lands on the
 * game. The server session is left `active` on purpose: it can be resumed
 * from the dashboard later. With a PIN set the app locks at once; without one
 * nothing locks.
 */
import type { NavigateFunction } from 'react-router-dom';
import type { AppDispatch } from '../store';
import { clearCurrentPrompt, resetGame } from '../store/slices/gameSlice';
import { requestAppLock } from './pinLock';

export const DECOY_PATH = '/notes';

export function panicExit({
  dispatch,
  navigate,
}: {
  dispatch: AppDispatch;
  navigate: NavigateFunction;
}): void {
  dispatch(clearCurrentPrompt());
  dispatch(resetGame());
  navigate(DECOY_PATH, { replace: true });
  try {
    window.history.replaceState(window.history.state, '', DECOY_PATH);
  } catch {
    // Some sandboxes block history writes; the router replace already ran.
  }
  requestAppLock();
}
